import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

class BaseSite extends React.Component {
  static get displayName() {
    return "BaseSite";
  }

  static get propTypes() {
    return {
      children: PropTypes.node,
      sidebar: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      sidebar: true,
    };
  }

  render() {
    const { children, sidebar } = this.props;

    const wrapperClasses = classNames({
      wrapper: true,
      "no-sidebar": !sidebar,
    });

    return (
      <div className={classNames("skin-blue", "sidebar-mini")}>
        <div className={wrapperClasses}>{children}</div>
      </div>
    );
  }
}

export { BaseSite };
